import store from '@/vuex/store'

const showTutorial=(domElementId, document, message, notifier)=>{
    // var app = document.getElementById("view-content");
    var app = document.getElementById("app");
    app.classList.add('blur');

    var element = document.getElementById(domElementId);
    element.classList.add('highlightedElement');

    store.commit("SET_SHOW_TUTORIAL", {show:true, message:message})
    notifier(message)
}

const hideTutorial=(document)=>{
    var app = document.getElementById("app");
    app.classList.remove('blur');
    store.commit("SET_SHOW_TUTORIAL",  {show:false})
}

export {showTutorial, hideTutorial}


// WEBPACK FOOTER //
// ./src/platform/utils/tutorial/index.js